export const products = {
  data: [
    {
      name: "Lẩu riêu cua",
      img: "https://nghebep.com/wp-content/uploads/2018/01/lau-rieu-cua-bap-bo.jpg",
      quantity: 789,
      price: 350000,
      address: "Hải Dương",
    },
    {
      name: "Lẩu nấm gà đen",
      img: "https://2trip.vn/wp-content/uploads/2023/02/lau-ga-den-ha-giang-4.jpg",
      quantity: 584,
      price: 400000,
      address: "Hải Dương",
    },
    {
      name: "Lẩu thái thập cẩm",
      img: "https://jamja.vn/blog/wp-content/uploads/2017/10/cach-lam-lau-thai-thap-cam-18.jpg",
      quantity: 951,
      price: 450000,
      address: "Hải Dương",
    },
    {
      name: "Lẩu trâu nhúng mẻ",
      img: "https://food.com.vn/upload/thuong-thuc-lau-trau-nhung-me-600x360.jpg",
      quantity: 472,
      price: 350000,
      address: "Hải Dương",
    },
    {
      name: "Gà hấp lá chanh",
      img: "https://yummyday.vn/uploads/images/ga-hap-la-chanh.jpg",
      quantity: 685,
      price: 280000,
      address: "hai",
    },
    {
      name: "Gà rang muối",
      img: "https://cdn.statically.io/img/gachaybo.com/f=auto/wp-content/uploads/2021/04/thit-ga-rang-muoi-1.jpg",
      quantity: 685,
      price: 220000,
      address: "hai",
    },
    {
      name: "Gà quay",
      img: "https://cachlammonngon.vn/wp-content/uploads/2016/05/ga-quay-tu-buu.jpeg",
      quantity: 685,
      price: 220000,
      address: "hai",
    },
    {
      name: "Bò xào trúc",
      img: "https://digifood.vn/blog/wp-content/uploads/2021/12/mang-truc-xao-thit-bo-1.jpg",
      quantity: 657,
      price: 130000,
      address: "hai",
    },
    {
      name: "Đuôi bò hầm tiêu xanh + bánh mì (Nồi)",
      img: "https://i.ytimg.com/vi/2k_Y9VFxSpw/maxresdefault.jpg",
      quantity: 257,
      price: 300000,
      address: "hai",
    },
    {
      name: "Bò xốt tiêu đen + bánh bao",
      img: "https://anhemfood.com/wp-content/uploads/2023/05/bo-sot-tieu-den-cham-banh-mi-1.jpg",
      quantity: 421,
      price: 120000,
      address: "hai",
    },
    {
      name: "Tôm chiên hoàng bào",
      img: "https://i.ytimg.com/vi/Dwkn_Yct5yc/maxresdefault.jpg",
      quantity: 487,
      price: "300000",
      address: "hai",
    },
    {
      name: "Cá song hấp xì dầu",
      img: "https://i.ytimg.com/vi/lWFz08izdik/maxresdefault.jpg",
      quantity: 178,
      price: 650000,
      address: "hai",
    },
    {
      name: "Mực xào ngũ sắc",
      img: "https://cdn3.ivivu.com/2020/05/muc-xao-ot-chuong-ivivu-4.jpg",
      quantity: 875,
      price: 150000,
      address: "hai",
    },
    {
      name: "Ngỗng xào lăn",
      img: "https://mgd.vn/wp-content/uploads/2021/01/huong-dan-mon-ngong-xao-lan-va-sa-ot-2.jpg",
      quantity: 321,
      price: 120000,
      address: "hai",
    },
    {
      name: "Cá quả nướng dân tộc",
      img: "https://banhtrangthitheophucuong.vn/wp-content/uploads/2022/05/Ca-qua-nuong-7.jpg",
      quantity: 258,
      price: 180000,
      address: "hai",
    },
    {
      name: "Bò hầm kiểu pháp + bánh mỳ (Nồi)",
      img: "https://2monngonmoingay.com/wp-content/uploads/2022/07/3.jpg",
      quantity: 458,
      price: 300000,
      address: "hai",
    },
    {
      name: "Gỏi bò rau tiến vua",
      img: "https://rangsua.vn/wp-content/uploads/2023/03/Bap-bo-muoi-rau-tien-vua-1068x1063.jpg",
      quantity: 632,
      price: 120000,
      address: "hai",
    },
    {
      name: "Nộm sứa xoài dừa",
      img: "https://i.ytimg.com/vi/itGIw_BeT24/maxresdefault.jpg",
      quantity: 758,
      price: 120000,
      address: "hai",
    },
    {
      name: "Nem hải sản",
      img: "https://vit29.com/media/product/171_nem_hai_san_2.jpg",
      quantity: 78,
      price: 80000,
      address: "hai",
    },
    {
      name: "Mực xào sa tế",
      img: "https://saithanhfoods.com/wp-content/uploads/2021/06/muc-xao-sa-te-230621b.jpg",
      quantity: 478,
      price: 150000,
      address: "hai",
    },
    {
      name: "Dê tái chanh",
      img: "http://cdn.tgdd.vn/Files/2021/07/28/1371443/cong-thuc-lam-mon-de-tai-chanh-don-gian-khong-bi-hoi-ma-cuc-thom-ngon-202112291548216472.jpg",
      quantity: 658,
      price: 120000,
      address: "hai",
    },
    {
      name: "Củ quả luộc + kho quẹt",
      img: "https://trixie.com.vn/media/images/product/32091875/Ngu-qua-kho-quet-1.jpg",
      quantity: 95,
      price: 40000,
      address: "hai",
    },
    {
      name: "Cá tầm nướng dân tộc",
      img: "https://www.cet.edu.vn/wp-content/uploads/2019/04/ca-tam-nuong-muoi-ot.jpg",
      quantity: 147,
      price: 300000,
      address: "hai",
    },
    {
      name: "Mực chiên bơ",
      img: "https://haithuycatering.com/image/5c3060a951046d646e1726cc/original.jpg",
      quantity: 423,
      price: 150000,
      address: "hai",
    },
    {
      name: "Ngọn su xào tỏi",
      img: "https://tse4.explicit.bing.net/th?id=OIP.jirPZpb80Wju_ksnfIJutgAAAA&pid=Api&P=0&h=220",
      quantity: 121,
      price: 300000,
      address: "hai",
    },
    {
      name: "Cải chip xào nấm",
      img: "https://anchay.cdn.vccloud.vn/wp-content/uploads/2021/11/photo-2-3-768x630.jpg",
      quantity: 78,
      price: 40000,
      address: "hai",
    },
    {
      name: "Sườn chiên tỏi",
      img: "https://i.ytimg.com/vi/u_nnKuu7X0o/maxresdefault.jpg",
      quantity: 321,
      price: 100000,
      address: "hai",
    },
    {
      name: "Sườn xào chua ngọt",
      img: "https://cdn.toponseek.com/sites/7/2022/06/huong-dan-cach-lam-suon-chien-nuoc-mam-ngon-don-gian.jpg",
      quantity: 425,
      price: 100000,
      address: "hai",
    },
    {
      name: "cá tầm trộn hành tím",
      img: "https://lahata.vn/files/news/2022/02/18/-153024.jpg",
      quantity: 171,
      price: 250000,
      address: "hai",
    },
    {
      name: "Chim câu quay",
      img: "https://mayvatlongga123.com.vn/wp-content/uploads/2022/02/cach-lam-chim-bo-cau-quay.jpg",
      quantity: 149,
      price: 130000,
      address: "hai",
    },
    {
      name: "Canh măng sườn",
      img: "https://cookbeo.com/media/2020/12/canh-mang-suon/canh-mang-suon.jpg",
      quantity: 865,
      price: 80000,
      address: "hai",
    },
    {
      name: "Canh ngao chua",
      img: "https://bearvietnam.vn/wp-content/uploads/canh-ngao-chua.jpg",
      quantity: 423,
      price: 50000,
      address: "hai",
    },
    {
      name: "Xôi hoàng phố",
      img: "https://i.ytimg.com/vi/VQz_cN8o5iY/maxresdefault.jpg",
      quantity: 255,
      price: 50000,
      address: "hai",
    },
  ],
  panigation: {
    perPage: 16,
  },
};
